import React, { useState } from 'react';
import { Select, MenuItem, Box, Typography } from '@mui/material';
import { useTranslation } from '../hooks/useTranslation';
import { PrimaryInput } from './PrimaryInput';

const countries = [
  { code: 'lu', label: 'luxembourg' },
  { code: 'ge', label: 'germany' },
  { code: 'fr', label: 'france' },
  { code: 'be', label: 'belgium' },
  { code: 'other', label: 'other' },
];

export const CountrySelector = (props) => {
  const { isError, setData, data } = props;
  const { t } = useTranslation();
  const [selectedCountry, setSelectedCountry] = useState(
    data?.isOtherCountry ? 'other' : data?.country || 'luxembourg'
  );
  const handleCountryChange = (event) => {
    setSelectedCountry(event.target.value);
    setData({
      ...data,
      errors: { ...data?.errors, counry: false },
      country: event.target.value === 'other' ? '' : event.target.value,
      isOtherCountry: event.target.value === 'other',
    });
  };
  const handleOtherCountryChange = (event) => {
    setSelectedCountry('other');
    setData({
      ...data,
      country: event.target.value,
      isOtherCountry: true,
      errors: { ...data?.errors, counry: false },
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'stretch',
      }}
    >
      {' '}
      <div
        style={{
          cursor: 'pointer',
          borderRadius: '4px',
          height: '48px',
        }}
      >
        <Select
          value={selectedCountry}
          onChange={handleCountryChange}
          displayEmpty
          native={false}
          IconComponent={() => (
            <div style={{ width: '26px', height: '26px', marginLeft: '-55px' }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <rect
                  opacity="0.1"
                  width="26"
                  height="26"
                  rx="13"
                  transform="matrix(-1 0 0 1 26 0)"
                  fill="#44546A"
                />
                <path
                  d="M10 13L13 15L16 13"
                  stroke="#44546A"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          )}
          MenuProps={{
            getContentAnchorEl: null, // Fixes positioning issues on mobile

            disablePortal: true,
            sx: {},
            MenuListProps: {
              sx: {
                marginTop: '8px',
                padding: '0',
                background: 'white',
              },
            },
            PaperProps: {
              sx: {
                background: 'transparent',
                boxShadow: 'none',
              },
            },
          }}
          inputProps={{
            sx: {
              padding: '0',
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {},
            },
          }}
          renderValue={(v) => {
            let country =
              countries.find((x) => x?.label === selectedCountry) ||
              countries[4];
            return (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                sx={{ gap: '8px', width: '90%' }}
              >
                {!data?.isOtherCountry && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '22px',
                      height: '22px',
                      borderRadius: '50%',
                    }}
                  >
                    {' '}
                    <img
                      src={'' + country.code + '.png'}
                      alt={country.code}
                      style={{
                        width: '22px',
                        height: '22px',
                        borderRadius: '50%',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                )}

                <Typography
                  sx={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#44546A',
                    lineHeight: '21px',
                    textTransform: 'capitalize',
                  }}
                >
                  {t('countryPage.' + country.label)}
                </Typography>
              </Box>
            );
          }}
          sx={{
            cursor: 'pointer',
            width: '100%',
            padding: '13px',
            borderRadius: '4px',
            height: '48px',
            background: 'white',
            //border:'1px solid #B8B7BB',

            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
          }}
        >
          {countries.map((country, i) => (
            <MenuItem
              key={country.code}
              value={country.label}
              native={false}
              sx={{
                height: '48px',
                borderRadius: '4px',
                width: '100%',
                background: 'white',
                padding: '0px',
                paddingInline: '13px',
                maxHeight: '48px',

                borderBottom:
                  i !== countries?.length - 1 ? '1px solid #F6F4F0' : '',
                '&.Mui-selected': {
                  background: 'white',
                  '&:hover': {
                    background: '#F6F4F0',
                  },
                },
                '& .MuiButtonBase-root': {
                  maxHeight: '20px',
                },
                '&:hover': {
                  background: '#F6F4F0',
                },
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                sx={{ gap: '8px', width: '90%' }}
              >
                {i !== countries?.length - 1 && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '22px',
                      height: '22px',
                      borderRadius: '50%',
                      border:
                        country.label === selectedCountry
                          ? '2px solid #00D1D2'
                          : '',
                    }}
                  >
                    {' '}
                    <img
                      src={'' + country?.code + '.png'}
                      alt={country?.code}
                      style={{
                        width:
                          country.label === selectedCountry ? '14px' : '22px',
                        height:
                          country.label === selectedCountry ? '14px' : '22px',
                        borderRadius: '50%',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                )}

                <Typography
                  sx={{
                    fontSize: '16px',
                    fontWeight:
                      country.label === selectedCountry ? '700' : '600',
                    color: '#44546A',
                    lineHeight: '21px',
                    textTransform: 'capitalize',
                  }}
                >
                  {t('countryPage.' + country.label)}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: '900',
                    color: '#00D1D2',
                    lineHeight: '21px',
                    textTransform: 'uppercase',
                    position: 'absolute',
                    right: '13px',
                    display: country.label === selectedCountry ? '' : 'none',
                  }}
                >
                  {t('countryPage.selected')}
                </Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </div>
      {selectedCountry === 'other' && (
        <PrimaryInput
          placeholder={t('countryPage.placeholder')}
          sx={{ marginTop: '12px' }}
          type="string"
          id="country"
          error={isError(data)}
          value={data?.country}
          onChange={handleOtherCountryChange}
        />
      )}
    </div>
  );
};

export default CountrySelector;
